<template>
  <div class="explore">
    <div class="search_input" @click="gotoSearch">
      <div class="title">请输入搜索关键词</div>
      <van-icon class="icon" name="search" />
    </div>

    <van-tabs v-model="active" @click="onClickTab">
      <van-tab title="班级">
        <clazz-tab :clazz-type="clazzTypes[0]" />
      </van-tab>
      <van-tab title="赛事">
        <race-tab />
      </van-tab>
    </van-tabs>

    <!-- <van-tabs v-model="active" color="#f5222d" @click="onClickTab">
      <clazz-tab v-for="(item, index) in clazzTypes" :key="index" :clazz-type="item" />
    </van-tabs> -->
  </div>
</template>

<script>
import { Icon, Tabs, Tab } from 'vant'
import ClazzTab from './components/ClazzTab'
import RaceTab from './components/RaceTab'

export default {
  name: 'explore',
  components: {
    [Icon.name]: Icon,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    ClazzTab,
    RaceTab
  },
  data () {
    return {
      active: 0,
      clazzTypes: [
        { clazz_type: '', title: '全部', hasClick: true },
        { clazz_type: 1, title: '跑步', hasClick: false },
        { clazz_type: 2, title: '减脂', hasClick: false }
        // { clazz_type: 3, title: '健身', hasClick: false }
      ]
    }
  },
  created () {
    let active = parseInt(this.$route.hash.substring(1))
    this.active = isNaN(active) ? 0 : active
  },
  methods: {
    gotoSearch () {
      this.$router.push('/search')
    },
    onClickTab (index, title) {
      window.location.hash = '#' + index
    }
  }
}
</script>

<style scoped lang="scss">
.search_input {
  width: 720px;
  height: 62px;
  box-sizing:border-box;
  margin: 15px auto 15px;
  padding: 0 15px;
  background-color: #eee;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #bbb;
  .title {
    font-size: 24px;
  }
  .icon {
    font-size: 36px;
  }
}
</style>
